import React from "react";
import {
  formatDateTime,
  Table,
  TableConfig, // eslint-disable-line no-unused-vars
  TableData, // eslint-disable-line no-unused-vars
} from "isuppli-react-components";

import {
  AuditEntryMessage, // eslint-disable-line no-unused-vars
} from "../../../http/audit/audit";
import { subSystemToString } from "../../../util/Enumerators/SubSystem";

const AuditTable = (
  {
    data,
    loading,
    onPageChange,
  }
  :
  {
    data: TableData<AuditEntryMessage>,
    loading: boolean,
    onPageChange: (limit: number, offset: number) => void;
  }
) => {
  const tableConfig: TableConfig<number, AuditEntryMessage> = {
    columns: [
      {
        key: "system",
        heading: "System Area",
        valueTemplate: (row) => <span>{subSystemToString(row.system)}</span>,
        size: "1fr",
      },
      {
        key: "date",
        heading: "Date & Time",
        valueTemplate: (row) => <span>{formatDateTime(row.dateTime)}</span>,
        size: "1fr",
      },
      {
        key: "action",
        heading: "Action",
        propName: "description",
        align: "left",
        size: "3fr",
      },
      {
        key: "supplierRegName",
        heading: "Supplier Reg Name",
        valueTemplate: (row) => (
          <span>
            {`${row.supplierAccount?.registeredName ?? "n/a"}`}
          </span>
        ),
        size: "1fr",
      },
      {
        key: "supplierRegNumber",
        heading: "Supplier Reg No.",
        valueTemplate: (row) => (
          <span>
            {`${row.supplierAccount?.registrationNumber ?? "n/a"}`}
          </span>
        ),
        size: "1fr",
      },
      {
        key: "user",
        heading: "Performed by",
        valueTemplate: (row) => (
          <span>
            {`${row.systemAction ? "System Action" : row.userFullName ?? "Unknown User"}${
              row.userEmail == null
                ? ""
                : ` (${row.userEmail})`
            }`}
          </span>
        ),
        size: "1fr",
      },
    ],
  };

  return (
    <Table
      onPageChange={onPageChange}
      tableConfig={tableConfig}
      loading={loading}
      tableStyle="default"
      data={data}
    />
  );
};

export default AuditTable;
